import optionOtcTradeCfg from '@/view/bizCfg/optionOtcTradeCfg/index.vue'



export default [
    { path: '/bizCfg/optionOtcTradeCfg', component: optionOtcTradeCfg, meta: '期权代理配置' },

]
